
import { Stage, UserJourney } from '@/types/journey';

export const calculateCompletionPercentage = (stages: Stage[], journey: UserJourney): number => {
  if (stages.length === 0) return 0;
  
  let totalFields = 0;
  let filledFields = 0;
  
  totalFields += 5;
  if (journey.userName) filledFields++;
  if (journey.userRole) filledFields++;
  if (journey.userPhoto) filledFields++;
  if (journey.scenario) filledFields++;
  if (journey.goal) filledFields++;
  
  totalFields += 2;
  if (journey.insights.gaps) filledFields++;
  if (journey.insights.opportunities) filledFields++;
  
  stages.forEach(stage => {
    totalFields += 5;
    if (stage.title && stage.title !== `Stage ${stages.indexOf(stage) + 1}`) filledFields++;
    if (stage.description) filledFields++;
    if (stage.painPoints) filledFields++;
    if (stage.opportunities) filledFields++;
    if (stage.quote) filledFields++;
  });
  
  return Math.round((filledFields / totalFields) * 100);
};
